<template>
  <div>
    <p class="title-page">Contabilizar NCM</p>
    <TableContabilizar />
  </div>
</template>

<script>
import TableContabilizar from "../components/TableContabilizar.vue";

export default {
  name: "Contabilizar",

  components: {
    TableContabilizar,
  },
};
</script>
